module.exports = __webpack_public_path__ + "img/H3.a7d05fc5.png";